'use strict';

angular.module('user')
    .controller('UserMainController', ['AccountManager', function(AccountManager) {
        var vm = this;

        vm.hasPermission = AccountManager.hasPermission;
    }]);
